import React from 'react';
import {FormActions} from '../../../Presentation/components/common';
import {useAddProductForm} from '../hooks/useAddProductForm';
import {ProductFormProps} from '../models/ProductFormTypes';
import ProductFormFields from './ProductFormFields';

/**
 * AddProductForm Component
 * Refactored to follow clean architecture principles:
 * - Single Responsibility: Only handles form presentation
 * - Dependency Inversion: Uses custom hook for business logic
 * - Open/Closed: Extensible through props and composition
 */
const AddProductForm: React.FC<ProductFormProps> = ({
  onSubmit,
  onCancel,
  submitting,
  initial,
  submitLabel,
  allowStockChanges = true,
  canEditHasSerial = true
}) => {
  const {
    formState,
    formActions,
    imagePreviews,
    brands,
    tags,
    productTypes,
    brandsLoading,
    tagsLoading,
    typesLoading,
    handleSubmit,
    handleImageRemove
  } = useAddProductForm(initial);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const isEditMode = !!initial;
    handleSubmit(onSubmit, isEditMode, allowStockChanges);
  };

  return (
    <form onSubmit={handleFormSubmit} className="flex flex-col gap-8">
      <ProductFormFields
        formState={formState}
        formActions={formActions}
        imagePreviews={imagePreviews}
        onImageRemove={handleImageRemove}
        brands={brands}
        tags={tags}
        productTypes={productTypes}
        brandsLoading={brandsLoading}
        tagsLoading={tagsLoading}
        typesLoading={typesLoading}
        allowStockChanges={allowStockChanges}
        canEditHasSerial={canEditHasSerial}
      />

      <FormActions
        onSubmit={() => {
          const isEditMode = !!initial;
          handleSubmit(onSubmit, isEditMode, allowStockChanges);
        }}
        onCancel={onCancel}
        submitLabel={submitLabel || 'حفظ'}
        cancelLabel="إلغاء"
        isLoading={submitting || formState.isSubmitting}
        disabled={false}
        showReset={false}
      />
    </form>
  );
};

export default AddProductForm;
